import React, {useEffect, useState} from "react";
import {Modal} from "../../../../../components/modal/modal.jsx";
import Button from "../../../../../components/button/button.jsx";
import RegisteredLocation from "../../../../../components/registered-location/registered-location.jsx";
import {emptyAddress} from "../utils/schedule-garrison-utils.js";

const ScheduleGarrisonAddressModal = ({open, setOpen, value, onSave, entityCity = ""}) => {
    const [address, setAddress] = useState(emptyAddress());

    useEffect(() => {
        if (!open) return;
        const base = value ?? emptyAddress();
        setAddress(base.city ? base : {...base, city: entityCity});
    }, [open, value, entityCity]);

    const save = () => {
        onSave(address);
        setOpen(false);
    };

    return (
        <Modal open={open} setOpen={setOpen} title="Local" className="w-10/12">
            <Modal.Body className="max-h-[calc(100vh-180px)] overflow-auto">
                <RegisteredLocation
                    showTitle={false}
                    data={address}
                    setData={setAddress}
                    showSectors
                    storePlaceName
                    coordinatesRequired={false}
                />
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={save} actionFeedbackType='save'>Salvar</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ScheduleGarrisonAddressModal;